<script setup lang="ts">
import { NavigationBreadcrumbs } from '@shared/ui/menus'

import { useLessonDetailHeader } from '../../model/lessons/lesson-detail-header.hook'

defineOptions({
  name: 'LessonDetailHeader',
})

const props = defineProps<{
  title: string
}>()

const {
  config,
} = useLessonDetailHeader({ title: props.title })
</script>

<template>
  <NavigationBreadcrumbs
    :config="config"
  />
</template>
